export const initialTasterData = {
  firstName: "",
  lastName: "",
  phoneNumber: "",
  gender: null,
  dateOfBirth: null,
  education: null,
  smoking: null,
  milkAlternatives: [],
  milkFrequency: null,
  mayonnaiseFrequency: null,
  mayonnaiseTypes: [],
  flavorPreferences: [],
  dislikedSubstances: [],
  otherDislikedSubstances: "",
  dietType: null,
  tasteSense: null,
  smellSense: null,
  contrastingFlavorsEnjoying: null,
  subtleFlavorsDetecting: null,
  cooking: null,
  dinnerEating: [],
  everyDayDish: "",
  spicyEating: [],
  favoriteFoodTexture: [],
  snacks: null,
  ultimateSnack: "",
  saltAdding: null,
  drinksConsuming: [],
  regularDrink: null,
  coffeeInCafe: null,
  coffeeAtHome: null,
  sugarInCoffee: null,
  milkInCoffee: null,
  regularTea: null,
  sugarInTea: null,
};

export const genderSelectOptions = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Other" },
  { value: "rather-not-answer", label: "Rather not answer" },
];

export const educationSelectOptions = [
  { value: "middle-school", label: "Middle school" },
  { value: "high-school", label: "High school" },
  { value: "under-graduate", label: "Undergraduate degree" },
  { value: "graduate", label: "Graduate degree" },
  { value: "post-graduate", label: "Post-graduate degree" },
  { value: "other", label: "Other" },
  { value: "rather-not-answer", label: "Rather not answer" },
];

export const smokingSelectOptions = [
  { value: "yes", label: "Smoker" },
  { value: "no", label: "Non-smoker" },
  { value: "ex-smoker", label: "Ex-smoker" },
  { value: "rather-not-answer", label: "Rather not answer" },
];

export const milkAlternativesOptions = [
  { value: "cow-milk-3%", label: "Cow milk 3%" },
  { value: "cow-milk-1%", label: "Cow milk 1%" },
  { value: "oat-milk", label: "Oat milk" },
  { value: "soy-milk", label: "Soy milk" },
  { value: "rice-milk", label: "Rice milk" },
  { value: "almond-milk", label: "Almond milk" },
  { value: "cashew-milk", label: "Cashew milk" },
  { value: "goat-milk", label: "Goat milk" },
  {
    value: "not-drink",
    label: "I do not drink any kind of milk on a regular basis",
  },
  { value: "other", label: "Other" },
];

export const milkFrequencyOptions = [
  "Less than once per month",
  "1-3 times per month",
  "About once per week",
  "2-5 times per week",
  "Every day/most days",
  "None of the above",
  "Rather not answer",
];

export const mayonnaiseFrequencyOptions = [
  "Less than once per month",
  "1-3 times per month",
  "About once per week",
  "2-5 times per week",
  "Every day/most days",
  "None of the above",
  "Rather not answer",
];

export const mayonnaiseTypesOptions = [
  "Spicy Mayonnaise",
  "Regular Mayonnaise",
  "Vegan Mayonnaise",
];

export const flavorPreferencesOptions = [
  "Spicy",
  "Sweet",
  "Salty",
  "Bitter",
  "Umami (Savory)",
  "Sour",
  "No Preference",
  "Other",
];

export const dislikedSubstancesOptions = [
  "Cilantro",
  "Parsley",
  "Brussels Sprouts/Cabbage/Broccoli",
  "Asparagus",
  "Licorice",
  "Coffee",
  "Grapefruit",
  "Beer",
  "Alcohol",
  "Artificial sweeteners",
  "Beet",
  "Goat cheese",
  "Spicy foods",
  "Other",
];

export const dietTypeOptions = [
  "Vegan",
  "Vegetarian",
  "Pescatarian (eats fish but not meat)",
  "Omnivore",
];

export const tasteSenseOptions = ["Excellent", "Good", "Average", "Poor"];

export const smellSenseOptions = ["Excellent", "Good", "Average", "Poor"];

export const contrastingFlavorsEnjoyingOptions = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No, I prefer more harmonious combinations" },
];

export const subtleFlavorsDetectingOptions = [
  { value: "yes", label: "Mostly yes" },
  { value: "no", label: "Almost never" },
];

export const cookingOptions = [
  { value: "no", label: "No" },
  { value: "easy-recipes", label: "I follow easy recipes" },
  { value: "complex-recipes", label: "I follow complex recipes" },
  { value: "without-recipes", label: "I cook without a recipe" },
];

export const dinnerEatingOptions = [
  "Meat",
  "Seafood",
  "Italian",
  "Asian",
  "Thai",
  "Mexican",
  "Indian",
  "American",
];

export const spicyEatingOptions = [
  "Not at all",
  "🌶️",
  "🌶️🌶️",
  "🌶️🌶️🌶️",
  "🌶️🌶️🌶️🔥",
];

export const favoriteFoodTextureOptions = [
  "Crunchy",
  "Creamy",
  "Chewy",
  "Crispy",
  "Gelatinous",
  "Grainy",
  "Silky",
  "Flaky",
  "Spongy",
  "Juicy",
];

export const snacksOptions = [
  { value: "sweet", label: "Sweet" },
  { value: "salty", label: "Salty" },
  { value: "not-prefer", label: "I do not have a preference" },
];

export const saltAddingOptions = ["Yes", "No"];

export const drinksConsumingOptions = [
  "Sweetened/natural fruit juices",
  "Iced tea",
  "Fresh smoothies",
  "Sweetened soda",
  "Unsweetened soda",
  "Soda water",
  "Wine",
  "Beer",
];

export const regularDrinkOptions = ["Coffee", "Tea", "Both", "Neither"];

export const coffeeInCafeOptions = [
  "I don’t drink coffee",
  "Short espresso",
  "Double espresso",
  "Long espresso",
  "Americano",
  "Cappuccino",
  "Strong cappuccino",
  "Latte",
  "Instant coffee",
  "Instant coffee with milk",
  "Black coffee",
];

export const coffeeAtHomeOptions = [
  "I don’t drink coffee",
  "Short espresso",
  "Double espresso",
  "Long espresso",
  "Americano",
  "Cappuccino",
  "Strong cappuccino",
  "Latte",
  "Instant coffee",
  "Instant coffee with milk",
  "Black coffee",
];

export const sugarInCoffeeOptions = [
  "No",
  "Less than one teaspoon",
  "1-2 tablespoons",
  "More than 2 teaspoons",
  "Stevia",
  "Artificial sweetener",
];

export const milkInCoffeeOptions = [
  {
    value: "not-drink",
    label: "I do not use milk",
  },
  { value: "cow-milk-3%", label: "Cow milk 3%" },
  { value: "cow-milk-1%", label: "Cow milk 1%" },
  { value: "oat-milk", label: "Oat milk" },
  { value: "soy-milk", label: "Soy milk" },
  { value: "rice-milk", label: "Rice milk" },
  { value: "almond-milk", label: "Almond milk" },
  { value: "cashew-milk", label: "Cashew milk" },
  { value: "goat-milk", label: "Goat milk" },
  { value: "other", label: "Other" },
];

export const regularTeaOptions = [
  {
    value: "not-drink",
    label: "I do not drink tea",
  },
  { value: "plain-black", label: "Plain black" },
  { value: "flavored-black", label: "Flavored black (earl grey)" },
  { value: "green-tea", label: "Green tea" },
  { value: "flavored-green", label: "Flavored green tea" },
  { value: "greens", label: "Non caffeinated Herbal tea (greens)" },
  { value: "fruit-tea", label: "Non caffeinated fruit tea" },
  { value: "not-prefer", label: "I do not have a preference" },
];

export const sugarInTeaOptions = [
  "No",
  "Less than one teaspoon",
  "1-2 tablespoons",
  "More than 2 teaspoons",
  "Stevia",
  "Artificial sweetener",
];
